import { render, staticRenderFns } from "./DigitalTwin.vue?vue&type=template&id=110bdd69&scoped=true&"
import script from "./DigitalTwin.vue?vue&type=script&lang=js&"
export * from "./DigitalTwin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110bdd69",
  null
  
)

export default component.exports